<div class="modal-header text-center">
    <div class="icon-container">
      <img src="assets/img/svg/clock-black.svg" alt="Clock" class="icon-clock" />
    </div>
    <h2 class="modal-title w-100">{{ "flight.custom.expired-token" | translate }}</h2>
  </div>
  <div class="modal-body text-center">
    <p class="custom-text">{{ "flight.custom.expired-retry" | translate }}</p>
  </div>
  <div class="modal-footer justify-content-center">
    <button class="custom-btn" (click)="onRestartSearch()">{{ "flight.result-flight.continue" | translate }}</button>
  </div>
  